module.exports = __webpack_public_path__ + "assets/img/7980616a4cd4be24450cedac76e79b13.png";